(function ($, scanner) {
	scanner.scan = function (success) {
		var url = scanner.defaults.url;
		url += "Scan";
		$.ajax({
			url: url,
			dataType: "json",
			global: false,
			cache: false, // Javlja error, ali je prazan tekst errorThrown - ovo bi moglo biti rješenje.			
			success: function (data) {
				var res = data.result;
				var filename = res[0];
				var bytes = res[1];
				if (!bytes) {
					return;
				}
				
				var array = new Uint8Array(bytes);
				var binary = "";
				for (var i = 0; i < bytes.length; ++i) {
					binary += String.fromCharCode(bytes[i]);
				}
				var base64 = btoa(binary);
				success(filename, base64);
			},
			error: function (jqXHR, textStatus, errorThrown) {				
				var customMsg = "";
				var errorText = "";				
				if (textStatus == "timeout") { //ovo mislim da ne radi
					customMsg = "<p><strong>Konto servis za skeniranje nije dostupan. Provjerite jeste li pokrenuli 'Konto Sign and Scan' aplikaciju za skeniranje, pa pokušajte ponovno.</strong></p>";					
				}				
				var errorText = errorThrown;
				if ((errorText == "") && (customMsg == "")) {
					errorText = "Konto servis za skeniranje nije dostupan. Provjerite jeste li pokrenuli aplikaciju 'Konto Sign and Scan', pa pokušajte ponovno.";					
				} else {
					customMsg = "<p><strong>Provjerite da li je skener priključen i upaljen.</strong></p>";					
				}				
				prikaziGresku(textStatus, errorText, customMsg);
			}
		});
	};
	
	vratiGresku = function(textStatus, errorText, customMessage) {		
		var kontoPoznataGreska = false;
		var errorKod =0;
		if (errorText.includes("Certifikat nije pronađen")) {
			kontoPoznataGreska = true;
			errorKod =1;
		} else if (errorText.includes("Neuspješna provjera")) {
			kontoPoznataGreska = true;
			errorKod =2;
		} else if (errorText.includes("Certifikat za potpis nije dostupan (USB stick, uređaj za kartice) ili ste upisali pogrešan pin.")) {
			kontoPoznataGreska = true;
			errorKod =3;
			errorText = "Certifikat za potpis nije dostupan (USB stick, uređaj za kartice) ili ste upisali pogrešan pin.";
		} else if (errorText.includes("Ulazni pdf stream mora biti zadan")) {
			kontoPoznataGreska = true;
			errorKod =4;
		} else if (errorText.includes("Izlazni pdf stream mora biti zadan")) {
			kontoPoznataGreska = true;
			errorKod =5;
		} else if (errorText.includes("Nije moguće potpisati već encryptirani pdf")) {
			kontoPoznataGreska = true;
			errorKod =6;
		} else if (errorText.includes("instalirana verzija programa")) {
			kontoPoznataGreska = true;
			errorKod =7;		
		} else if (errorText.includes("pdfPotpisi256 method not found")) {
			kontoPoznataGreska = true;
			errorKod =8;
			errorText = "Metoda za napredno potpisivanje nije pronađena.";			
		}		

		if (kontoPoznataGreska) {
			var c = $("<div>");
			c.append("<p><strong>Obavijest: </strong><strong style='color:red;'>" + errorText + "</strong></p>");			
			if ((errorKod == 7) || (errorKod == 8)) {				
				c.append("<p>Potrebno je instalirati novu verziju programa Konto Sign And Scan.</p>");
				c.append("<p>Javite se informatičaru ili sami instalirajte novu verziju programa sa sljedeće poveznice:   " + 
				"<a href='"+kontorouter.defaults.basePath+"bin/"+kontorouter.defaults.kssApp+"'><i class='fas fa-download'></i><span class='title'>Preuzimanje nove verzije programa za potpisivanje i vezu sa skenerom</span></a>&nbsp;&nbsp;&nbsp;"+
				"<a href='"+kontorouter.defaults.basePath+"bin/KontoSignScan.pdf'>(<i class='fas fa-download'></i><span class='title'>Upute)</span></a></p>");
				c.append("<p>Javite se u Konto, ukoliko vam se i nakon instalacije nove verzije programa javlja greška prilikom skeniranja ili potpisivanja.</p>");
			}			
		} else {
			var c = $("<div>");
			c.append("<p><strong>Dogodila se greška! Detalji greške: </strong><strong style='color:red;'>" + textStatus + " - " + errorText + "</strong></p>");
			
			c.append("<p>Moguća rješenja:</p>");		
			
			if(customMessage){
				c.append(customMessage);			
			}
	
			c.append("<p>Provjerite da li je servis 'Konto Sign and Scan' pokrenut.</p>");
			
			c.append("<p>Provjerite da li su ispravno definirani parametri 'Konto Sign and Scan' servisa. Adresa servera mora biti točna, paziti na http/https.");		
	
			var ot = $("<p>");
			ot.append("U slučaju da je servis pokrenut, moguća rješenja su:");
	
			var rj = $("<ul>");
			
			var ie = $("<li>");
			ie.append("Ako koristite Internet Explorer: dodati trenutnu stranicu u trusted siteove");
			
			var inace = $("<li>");
			inace.append("Možete dodati iznimku klikom na sljedeći link: <a href=\"" + scanner.defaults.url + "Ping" + "\" target=\"_blank\">'Konto Sign and Scan'</a>. Potrebno je prihvatiti iznimku i nakon toga se vratiti u ovaj prozor.");
			
			rj.append(ie);
			rj.append(inace);
			
			c.append(ot);
			c.append(rj);
		}

		return c;		
	};	
	
	prikaziGresku = function(textStatus, errorText, customMessage) {
        var greskaText = vratiGresku(textStatus, errorText, customMessage);	
        	
		$.dialog({
			content: greskaText,
			title: "Pomoć"
		});		
	};

	
	scanner.barkodUcitaj = function (callback) {
		var url = scanner.defaults.url;
		url += "BarkodUcitaj";
		$.when(
			$.ajax({
				url: url,
				cache: false,
				error: function (jqXHR, textStatus, errorThrown) {				
					var customMsg = "";
					var errorText = errorThrown;
					prikaziGresku(textStatus, errorText, customMsg);
				}
			})
		).then(function(res){
			var obj = JSON.parse(res);
			if (obj.result[0] != ''){
				if (typeof callback === 'function') {
					callback(obj.result.toString())
				}
			};
		});		
	};

	scanner.otvoriFolder = function(folder) {
		var url = scanner.defaults.url;
		url += "OtvoriFolder/" + encodeURI(folder);
		$.ajax({
			url: url,
			cache: false,
			error: function (jqXHR, textStatus, errorThrown) {				
				var customMsg = "";
				var errorText = errorThrown;
				prikaziGresku(textStatus, errorText, customMsg);				
			}
		});		
	};

	scanner.pdfPotpisi = function(data, callback) {
		var url = scanner.defaults.url;
		url += '"pdfPotpisi256"';
		$.ajax({
			url: url,
			cache: false,
			method: "POST",
			dataType: "json",
			contentType: "multipart/form-data",	
			//headers: {"Access-Control-Allow-Origin": "*"},
			data: data,
			success: function(data, textStatus, jqXHR){
				callback(data.result[0]);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				var customMsg = "";				
				var errorText = "";				
				if (jqXHR.responseJSON) {
					errorText = jqXHR.responseJSON.error;					
				} else {
					errorText = errorThrown;					
				}
				if ((errorText == "") && (customMsg == "")) {
					errorText = "Konto servis za digitalni potpis nije dostupan. Provjerite jeste li pokrenuli 'Konto Sign and Scan' aplikciju za potpisivanje, pa pokušajte ponovno.";
				} else {
					customMsg = "<p><strong>Provjerite da li je uređaj za digitalno potpisivanje (USB stick ili uređaj za karticu) priključen i aktivan, te da imate instaliranu podršku za uređaj.</strong></p>";
				}				
				prikaziGresku(textStatus, errorText, customMsg);
				jqXHR.statusText = "errorOverride";
			}
		});		
	};

	scanner.pdfPotpisiBezDizanjaErrora = function(data, callback, errorcallback) {
		var url = scanner.defaults.url;
		url += '"pdfPotpisi256"';
		$.ajax({
			url: url,
			cache: false,
			method: "POST",
			dataType: "json",
			contentType: "multipart/form-data",	
			//headers: {"Access-Control-Allow-Origin": "*"},
			data: data,
			success: function(data, textStatus, jqXHR){
				callback(data.result[0]);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				var customMsg = "";				
				var errorText = "";				
				if (jqXHR.responseJSON) {
					errorText = jqXHR.responseJSON.error;					
				} else {
					errorText = errorThrown;					
				}
				if ((errorText == "") && (customMsg == "")) {
					errorText = "Konto servis za digitalni potpis nije dostupan. Provjerite jeste li pokrenuli 'Konto Sign and Scan' aplikciju za potpisivanje, pa pokušajte ponovno.";
				} else {
					customMsg = "<p><strong>Provjerite da li je uređaj za digitalno potpisivanje (USB stick ili uređaj za karticu) priključen i aktivan, te da imate instaliranu podršku za uređaj.</strong></p>";					
				}

				var grText = vratiGresku(textStatus, errorText, customMsg);
				jqXHR.statusText = "errorOverride";				
				errorcallback(grText);				 
			}
		});		
	};
// Ovo se radi na Datasnap-u	
/*	
	scanner.potpisanDokumentUpisi = function(data, callback, saPorukom) {
		var url = kontorouter.getModulPath("dokument/PotpisanDokumentUpisi");
		var json = data.result[0];
		
		$.fileDownload(url + "?fileDownload", {
			httpMethod: "POST",
			data: json,
			prepareCallback: function (url) {
				if (saPorukom) {
					dlg = konto.dialogs.modal({
						title: "Potpisivanje dokumenta",
						content: "Molimo pričekajte."
					});
				}
			},
			successCallback: function () {
				if (saPorukom) {				
					if (dlg)
						dlg.close();
				}
				callback();
			},
			failCallback: function (responseHtml, url) {
				if (saPorukom) {				
					if (dlg)
						dlg.close();
				}
			
				var potpisan = false;
				var html = $(responseHtml);   
				try {                      
					var json = $.parseJSON(html.text());
					if (json && json.error) {
						potpisan = true;
						if (saPorukom) {						
							$.dialog({
								content: json.error
							});
						}
					}
				}
				catch (e) { }
				
				if (potpisan === false) {
					if (responseHtml == '')
						responseHtml = "Dokument nije potpisan." + "<p>" + e + "</p>";
					if (saPorukom) {						
						$.dialog({
							content: responseHtml
						});
					}
				}
			}
		});	
	};	
*/
	scanner.getFileUrl = function (path) {
		return scanner.defaults.url + "GetFile/" + path;
	};
	
	scanner.defaults = {
		url: "//localhost:9080/datasnap/rest/TScanMethods/"
	};
} (jQuery, window.scanner = window.scanner || {}));